import React, { useMemo } from "react"
import { css } from "emotion"
import Update from "./Update"
import type { Thread, User, Comment } from "../types"

type WithIndex<T> = T & { index: number }

export interface UpdatesProps {
	threads: Thread[]
	user: User
	onClose: () => void
	onOpenThread: (threadIndex: number) => void
}

// function doesCommentMentionUser(comment: Comment, user: User) {
// 	let json = JSON.parse(comment.message)

// 	for (let entity in json.entityMap) {
// 		let value = json.entityMap[entity]
// 		if (value.type == "mention" && value.data.mention.name === user.name) {
// 			return true
// 		}
// 	}

// 	return false
// }

export default function Updates(props: UpdatesProps) {
	let { threads } = props

	// let mentionedComments = useMemo(() => {
	// 	let comments: WithIndex<Comment>[] = []

	// 	threads.forEach((thread, index) => {
	// 		thread.comments.forEach((comment) => {
	// 			if (doesCommentMentionUser(comment, user)) {
	// 				mentionedComments.push({ ...comment, index })
	// 			}
	// 		})
	// 	})

	// 	return comments
	// }, [threads, user])

	let reversedComments = useMemo(() => {
		let comments: WithIndex<Comment>[] = []

		threads
			.slice()
			.reverse()
			.map((thread, index) => {
				for (let comment of thread.comments) {
					comments.push({ ...comment, index })
				}
			})

		return comments.reverse()
	}, [threads])

	return (
		<div
			className={css`
				width: 350px;
				max-height: 500px;
				position: fixed;
				bottom: 0.5rem;
				right: 0.5rem;
				display: block;
				justify-content: center;
				background-color: white;
				font-size: 12px;
				z-index: 1000000;
				border-radius: 20px;
				box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
			`}
		>
			<div
				className={css`
					align-items: center;
					width: 100%;
					height: 50px;
					background-color: #0284fe;
					display: flex;
					flex-direction: row;
					border-top-left-radius: 20px;
					border-top-right-radius: 20px;
				`}
			>
				<div
					className={css`
						width: 85%;
						height: 100%;
					`}
				/>
				<div
					onClick={props.onClose}
					className={css`
						text-align: center;
						width: 15%;
						font-size: 20px;
						color: white;

						&:hover {
							cursor: pointer;
							color: gray;
						}
					`}
				>
					x
				</div>
			</div>
			<div
				className={css`
					font-family: "SF Pro Text", -apple-system, BlinkMacSystemFont,
						"Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif,
						"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
						"Noto Color Emoji", Helvetica, Arial, sans-serif;
					overflow-y: scroll;
					height: 450px;
					display: flex;
					flex-direction: column;
				`}
			>
				{/* {mentionedComments.length > 0 && (
					<div
						className={css`
							font-family: "SF Pro Text", -apple-system, BlinkMacSystemFont,
								"Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans",
								sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
								"Segoe UI Symbol", "Noto Color Emoji", Helvetica, Arial,
								sans-serif;
							padding-left: 1.5em;
							padding-bottom: 10px;
							border-bottom: 1px solid #eaeaea;
						`}
					>
						<h2>
							👇Scoops For You
						</h2>
						<div>
							{mentionedComments.map((comment) => (
								<Update
									threads={threads}
									key={comment._id}
									comment={comment}
									threadIndex={comment.index}
									onOpen={props.onOpenThread}
								/>
							))}
						</div>
					</div>
				)} */}
				<div>
					<h2
						className={css`
							font-family: "SF Pro Text", -apple-system, BlinkMacSystemFont,
								"Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans",
								sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
								"Segoe UI Symbol", "Noto Color Emoji", Helvetica, Arial,
								sans-serif;
							padding-left: 1.5em;
							padding-bottom: 10px;
							border-bottom: 1px solid #eaeaea;
						`}
					>
						📥Scoops Of Jam
					</h2>
					<div>
						{reversedComments.map((comment) => (
							<Update
								threads={threads}
								key={comment._id}
								comment={comment}
								threadIndex={comment.index}
								onOpen={props.onOpenThread}
							/>
						))}
					</div>
				</div>
			</div>
		</div>
	)
}
